/** Where STORE's back button returns to (header coin chip / STORE channel vs the head picker's GET COINS). */
import { signal } from '@preact/signals';
import type { ScreenId } from '@hf/client-core/ui-model/types';

export type StoreTab = 'heads' | 'balls' | 'locker' | 'coins';
export const storeReturn = signal<ScreenId>('main_menu');
export const storeTab = signal<StoreTab>('heads');

/** Open the store from `from` via the (sign-in guarded) `goto`; back returns there. */
export const openStore = (goto: (s: ScreenId) => void, from: ScreenId, tab?: StoreTab): void => {
  if (from === 'store') return;
  storeReturn.value = from;
  if (tab) storeTab.value = tab;
  goto('store');
};
